var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-profile gutter frame"},[(_vm.form)?_c('div',[_c('h2',[_vm._v("Your Profile")]),_vm._v(" "),_c('edit-user',{attrs:{"form":_vm.form,"user":_vm.user},on:{"updated":_vm.updateUser}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }